/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Trans } from 'react-i18next';
import axios from 'axios';
class Navbar extends Component {
  logout = () => {
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    
    let baseUrl;
    if(nodeMode==="development"){
      baseUrl =  beckendLocalApiUrl;
    }else{
       baseUrl = beckendLiveApiUrl
    }
    
    const access_token = localStorage.getItem("token")
    const headers = {
      Authorization: `Bearer ${access_token}`
    }
    axios.post(baseUrl+`logout`, {
      headers: headers
    }, { headers })
      .then((res) => {
        localStorage.removeItem("token", "user")
        window.location.reload()
        window.location.assign("/adminlogin")
      }).catch((e) => {
        if (e && e.response && e.response.status === 401) {
          localStorage.removeItem('token', "user");
          window.location.assign("/adminlogin")
        }
      })
  }
  toggleOffcanvas() {
    document.querySelector('.sidebar-offcanvas').classList.toggle('active');
  }
  render() {
    // Premium Styles - Refined for Alignment
    const styles = `
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');
        
        .navbar { 
          background: #fff !important; 
          box-shadow: 0 4px 20px rgba(0,0,0,0.05); 
          border-bottom: none; 
          height: 70px; 
          font-family: 'Poppins', sans-serif;
          padding: 0; 
        }
        .navbar .navbar-menu-wrapper { 
          background: #fff; 
          padding: 0 20px; 
          color: #57155a;
          height: 70px;
          display: flex;
          align-items: center;
        }
        
        .navbar-toggler {
            border: none;
            background: transparent;
            padding: 0;
        }
        .navbar-toggler span { 
          color: #57155a !important; 
          font-size: 1.5rem; 
        }
        .navbar-brand-wrapper { 
          background: #f8f9fa; /* Slight contrast for logo area */
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          width: 70px; /* Standard mobile logo width */
        }
        
        /* Profile Section */
        .navbar-profile { 
          display: flex; 
          align-items: center; 
          gap: 12px; /* Increased gap */
          padding: 6px 15px; 
          border-radius: 30px; 
          transition: 0.3s; 
          background: #fff; 
          border: 1px solid #eee;
          box-shadow: 0 2px 5px rgba(0,0,0,0.02);
          height: 45px;
        }
        
        .navbar-profile:hover { 
          background: #fcfcfc; 
          border-color: #e0e0e0;
        }
        
        .img-profile { 
          width: 32px; 
          height: 32px; 
          border-radius: 50%; 
          border: 1px solid #57155a; 
          padding: 1px;
          object-fit: cover;
        }
        
        .profile-name { 
          font-weight: 600; 
          font-size: 0.85rem; 
          color: #333; 
          margin: 0;
          line-height: 1.1; 
        }
        
        .profile-role { 
          font-size: 0.70rem; 
          color: #888; 
          font-weight: 500;
          display: block; 
        }
        
        /* Dropdown */
        .navbar-dropdown { 
          border: none; 
          box-shadow: 0 10px 30px rgba(0,0,0,0.08); 
          border-radius: 12px; 
          padding: 8px; 
          min-width: 180px; 
          top: 55px !important; /* Force dropdown position down */
        }
        
        .dropdown-item { 
          padding: 8px 12px; 
          border-radius: 8px; 
          font-weight: 500; 
          color: #555; 
          display: flex; 
          align-items: center; 
          gap: 10px; 
          transition: 0.2s; 
        }
        
        .dropdown-item:hover { 
          background: #fff0f0; 
          color: #e74c3c; 
        }
        
        .logout-icon { 
          background: #fff5f5; 
          padding: 5px; 
          border-radius: 6px; 
          color: #e74c3c; 
          display: flex; 
          align-items: center; 
          justify-content: center; 
          width: 28px; 
          height: 28px; 
        }
        
        .user-welcome { 
          font-size: 1rem; 
          font-weight: 600; 
          color: #57155a; 
          margin: 0; 
        }
        .mdi-menu { font-size: 24px; }
        
        /* Remove default caret/arrow from dropdown toggle */
        .no-caret::after {
            display: none !important;
        }
    `;
    return (
      <nav className="navbar p-0 fixed-top d-flex flex-row">
        <style>{styles}</style>
        
        <div className="navbar-brand-wrapper d-flex d-lg-none align-items-center justify-content-center">
          <Link className="navbar-brand brand-logo-mini" to="/">
            <img 
              src='https://cdn-icons-png.flaticon.com/512/2206/2206368.png' 
              alt="logo" 
              width="32px"
              height="32px"
              style={{width:'32px', height:'32px'}}
            />
          </Link>
        </div>
        
        <div className="navbar-menu-wrapper flex-grow d-flex align-items-center justify-content-between">
          
          <div className="d-flex align-items-center">
             <button className="navbar-toggler align-self-center mr-2" type="button" onClick={() => document.body.classList.toggle('sidebar-icon-only')}>
                <span className="mdi mdi-menu"></span>
             </button>
             
             <div className="d-none d-md-block ml-3">
                 <h6 className="user-welcome">Hello, {this.props.userAname || 'Admin'} 👋</h6>
             </div>
          </div>
          <ul className="navbar-nav navbar-nav-right">
            <Dropdown alignRight as="li" className="nav-item">
              <Dropdown.Toggle as="a" className="nav-link cursor-pointer no-caret" style={{padding:0}}>
                <div className="navbar-profile">
                  <img 
                    className="img-profile" 
                    src="https://cdn-icons-png.flaticon.com/512/2206/2206368.png" 
                    alt="profile" 
                    width="32px"
                    height="32px"
                  />
                   <div style={{lineHeight:'1.2'}}>
                       <p className="profile-name"><Trans>{this.props.userAname || 'Admin'}</Trans></p>
                       <span className="profile-role"><Trans>{this.props.usertype || 'Super Admin'}</Trans></span>
                   </div>
                  <i className="mdi mdi-chevron-down" style={{color:'#ccc', fontSize:'18px'}}></i>
                </div>
              </Dropdown.Toggle>
              <Dropdown.Menu className="navbar-dropdown navbar-profile-dropdown-menu">
                <Dropdown.Item onClick={() => this.logout()} className="dropdown-item">
                    <div className="logout-icon">
                      <i className="mdi mdi-power"></i>
                    </div>
                    <span><Trans>Log Out</Trans></span>
                </Dropdown.Item> 
              </Dropdown.Menu>
            </Dropdown>
          </ul>
          
          <button className="navbar-toggler navbar-toggler-right d-lg-none align-self-center" type="button" onClick={this.toggleOffcanvas}>
            <span className="mdi mdi-dots-vertical"></span>
          </button>
          
        </div>
      </nav>
    );
  }
}
export default Navbar;